export abstract class ApiError extends Error {
  constructor(message: string) {
    super(message);
  }
}

export class ApiHttpError extends ApiError {
  private constructor(
    public readonly response: Response,
    message: string,
  ) {
    super(message);
  }

  static async create(response: Response, message?: string) {
    if (!response.ok) {
      return new ApiHttpError(
        response,
        message || `API HTTP Error ${response.status}: ${response.statusText}`,
      );
    }
  }
}

export class ApiConnectionError extends ApiError {
  constructor(
    public readonly cause: unknown,
    message: string,
  ) {
    if (cause instanceof Error) {
      message = cause.message;
    } else if (typeof cause === 'string') {
      message = cause;
    } else if (message === undefined) {
      message = 'Connection error';
    }
    super(message);
  }
}
